import React from 'react'

const Grid1 = () => {
  return (
    <div>
      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQAPMAaT2sxjxds0Hdq9qMYVawd1catRC6ZtQ&usqp=CAU"
       alt="img" style={{width:"100%", height:'100vh'}} />
    </div>
  )
}

export default Grid1
